oyc.ShadowStyleOverrides = {
  noAutoload: true,
  hosts: [
    {
      id: 'eyeAble_container_ID',
      styleId: 'oyc-eyeable-position',
      css: function () {
        const bottomOffset = document.body && document.body.classList.contains('job-single-page') ? '3em' : '0em';

        return `@media (min-width: 1023.98px) {
        #eyeAble_MainContainerID .eyeAble_mainicon_container  {
          bottom: 50% !important;
          transform: translateY(50%);
          right: auto!important;
          top: auto!important;
          left: 10px !important;
        }
      }
      @media (max-width: 1023.98px) {
        #eyeAble_MainContainerID .eyeAble_mainicon_container  {
          bottom: calc(1.9375em + ${bottomOffset}) !important;
          left: 20px !important;
          right: auto !important;
        }
        #eyeAble_MainContainerID #eyeAble_columID {
          left: 20px !important;
          bottom: calc(1.8175em + ${bottomOffset}) !important;
        }
      }`;
      }
    },
    {
      id: 'kauz-root',
      styleId: 'oyc-kauz-position',
      css: `#placeholder {right: 6px!important;}`
    }
  ],

  init: function () {
    const observer = new MutationObserver(this.applyStyles.bind(this));
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
    this.applyStyles();
    document.addEventListener('eyeable:event', (ev) => {
      if (ev.detail === 'Toolbar_Opened') {
        this.closeKauz();
      }
    });
  },

  applyStyles: function () {
    this.hosts.forEach((config) => {
      const host = document.getElementById(config.id);
      if (!host || !host.shadowRoot) {
        return;
      }

      if (!host.shadowRoot.getElementById(config.styleId)) {
        const style = document.createElement('style');
        style.id = config.styleId;
        style.textContent = typeof config.css === 'function' ? config.css() : config.css;
        host.shadowRoot.appendChild(style);
      }
    })
  },

  closeKauz: function () {
    const kauz = document.getElementById('kauz-root');
    if (!kauz || !kauz.shadowRoot) {
      return;
    }

    const eyeAble = document.getElementById('eyeAble_container_ID');
    const eyeAbleFocus = eyeAble && eyeAble.shadowRoot ? eyeAble.shadowRoot.activeElement : null;

    const greeting = kauz.shadowRoot.getElementById('greeting');
    window.dispatchEvent(new CustomEvent('kauz.chat.close', {
      detail: {avatarMessage: greeting ? greeting.innerHTML : ''}
    }));

    // Kauz moves the focus to its avatar on close, hand it back to Eye-Able for keyboard and screen reader users
    if (eyeAbleFocus) {
      eyeAbleFocus.focus();
    }
  }
}
oyc.ShadowStyleOverrides.init();
